import React, { useState, useEffect } from "react";
import GUIset_Single from "./gui/GUIset_Single";
import T from "./TheTool";
import Timer from "./TheTimer";
import Template from "./TheTemplate";

const Freq = () => {
	useEffect(() => {
		document.title =
			"Most Frequently Occurring Item in an Array (counting the occurrences / frequency of array elements)";
	}, []);

	const [guiTxt1, guiTxtChange1] = useState(
		"1,3,1,3,2,2,5,4,2,1,8,A,6,5,7,9,3,2,1,A,5,4"
	);
	//----
	const [partResult, partResultChange] = useState(<div></div>); //bottom part that show result

	const buttonClick1 = () => {
		if (guiTxt1 != "") {
			// arr = T.str_toListInt(guiTxt1);
			Timer.start();
			process();
			txt_time = Timer.stop_print();
			//--------------------------
			BuildResult();
			arr = [];
			result_list = {};
			result_mostfreq_x = [];
		}
	};

	var arr = [];
	var result_list = {};
	var result_mostfreq_x = [];
	var result_mostfreq_n = -1;
	var txt_time = "";
	var txt_result = "";

	function process() {
		ver2();
	}

	// function ver1_numberOnly(){
	// 	result_mostfreq_x = [];
	// 	result_mostfreq_n = -1;
	// 	txt_result = "";
	// 	//
	// 	var keys = [];
	// 	const counts = {};
	// 	for (const num of arr) {
	// 		var n = counts[num] ? counts[num] + 1 : 1;
	// 		counts[num] = n;
	// 		if (n == 1) {
	// 			keys.push(num);
	// 		}
	// 	}
	// 	result_list = counts;
	// 	//-------
	// 	keys.sort();
	// 	console.log("keys = " + keys);
	// 	for (var i = 0; i < keys.length; i++) {
	// 		let n = counts[keys[i]];
	// 		let t = keys[i] + " : " + n;
	// 		console.log(t);
	// 		if (txt_result != "") {
	// 			txt_result += "\n";
	// 		}
	// 		txt_result += t;
	// 		if (n > result_mostfreq_n) {
	// 			result_mostfreq_n = n;
	// 			result_mostfreq_x.push(keys[i]);
	// 		}
	// 	}
	// 	// result_list = counts;
	// 	// console.log("v = " + counts);
	// 	// console.log("v = " + counts.keys);
	// }

	function ver2() {
		result_mostfreq_x = [];
		result_mostfreq_n = -1;
		var freq = T.arr_getFrequency_str_remove(guiTxt1, ",");
		var i = 0;
		for (const [key, n] of Object.entries(freq)) {
			var k = parseInt(key);
			if (i > 0) txt_result += "\n";
			txt_result += key + " : " + n;
			//
			if (n > result_mostfreq_n) {
				result_mostfreq_n = n;
				result_mostfreq_x = [];
				result_mostfreq_x.push(key);
			}
			else if (n == result_mostfreq_n) {
				result_mostfreq_x.push(key);
			}
			i++;
		}
	}

	function BuildResult() {
		var txt = txt_time;
		txt += "\nMost frequently occurring item: " + result_mostfreq_x;
		txt += "\nHighest frequency: " + result_mostfreq_n;
		partResultChange(
			Template.simple01x2(
				"set1",
				"Result",
				txt,
				22,
				"Frequencies",
				txt_result,
				20
			)
		);
	}

	return (
		<GUIset_Single
			title={"Most Frequently Occurring Item"}
			desc={
				"Finding the most frequently occurring item in a given array (Counting the occurrences / frequency of array elements)."
			}
			guiTxt={guiTxt1}
			guiTxtChange={guiTxtChange1}
			buttonClick={buttonClick1}
			partResult={partResult}
			label1={"Array"}
			txtButton={"Analyze"}
		/>
	);
};

export default Freq;

// import GUI_Header from "./gui/GUI_Header";
// import GUI_InputTextSingle from "./gui/GUI_InputTextSingle";
// import GUI_Credit from "./gui/GUI_Credit";

// var txt = "";
// var txt2 = "";
// var part1 = [<div></div>];
// var part2 = [<div></div>];
//------------------------
// txt += txt_time + "\n";
// txt += "Most frequently occurring item: " + result_mostfreq_x;
// txt += "\nHighest frequency: " + result_mostfreq_n;
// txt2 += txt_result;
// 	//---------
// 	var part1 = Template.simple01("key1","Result",txt,22,22);
// 	var part2 = Template.simple01("key2","Frequencies",txt2,20,20);
// 	partResultChange(
// 		<div>
// 		{part1}
// 		{part2}
// 		</div>
// 	);
//---------

// <div className="todoapp stack-large">
// 	<GUI_Header
// 		title={"Most Frequently Occurring Item"}
// 		desc={
// 			"Finding the most frequently occurring item in a given array (Counting the occurrences / frequency of array elements) [number only]."
// 		}
// 	/>
// 	<div style={{ marginTop: "3em" }}> </div>
// 	<GUI_InputTextSingle
// 		label={"Array"}
// 		text1={guiTxt1}
// 		text1Change={guiTxtChange1}
// 		numberOnly={false}
// 		width1={100}
// 		fontSize2={24}
// 		width2={'100%'}
// 	/>
// 	<div style={{ display: "flex", marginLeft: '14%', marginRight: 0 }}>
// 		<button
// 			onClick={() => buttonClick1()}
// 			className="btn btn__primary btn__lg"
// 			style={{ flex: 1, height: 50 }}
// 		>
// 			Calculate
// 		</button>
// 	</div>
// 	<div style={{ marginTop: "3em" }}> </div>
// 	{partResult}
// 	<GUI_Credit />
// </div>
